import { FC, ReactNode } from 'react';

type Props = {
  label: string;
  children: ReactNode;
};

export const FormRow: FC<Props> = ({ label, children }) => {
  return (
    <div className="flex items-center gap-5">
      <label className="w-40 shrink-0 text-right font-medium">{label}</label>
      <div className="flex-1">{children}</div>
    </div>
  );
};
